import { c as p } from "../../../../index.esm-BeDSGXP5.js";
import { css as i } from "styled-components";
const n = ({ theme: o, angle: s, border: r, foregroundColor: t }) => /* @__PURE__ */ i([
  "content:'';position:absolute;height:350%;",
  " border-radius:50%;box-sizing:border-box;",
  " ",
  ";"
], s === "shallow" ? `
            width: 200%;
            left: -50%;
            right: -50%;
        ` : `
            width: 120%;
            left: -10%;
            right: -10%;
        `, r ? `border: 0.3rem solid ${o.componentColors.curve.border};` : "", p({
  backgroundColor: t
})), c = {
  base: ({ theme: o, variant: s, backgroundColor: r, angle: t, border: e, foregroundColor: a }) => /* @__PURE__ */ i([
    "height:",
    ";width:100%;margin:0 auto;position:relative;overflow:hidden;",
    " ",
    " ",
    "{height:",
    ";}",
    "{height:",
    ";}"
  ], o.space.sm, p({
    backgroundColor: r
  }), s === "up" ? /* @__PURE__ */ i([
    "&:before{top:0%;",
    ";}"
  ], n({
    theme: o,
    angle: t,
    border: e,
    foregroundColor: a
  })) : /* @__PURE__ */ i([
    "&:after{bottom:0%;",
    ";}"
  ], n({
    theme: o,
    angle: t,
    border: e,
    foregroundColor: a
  })), o.breakpoints.mq.tabletMin, o.space.md, o.breakpoints.mq.desktopMin, o.space.lg)
};
export {
  c as default
};
